export default __webpack_public_path__ + "static/Entenda0121-f724868b420e84c45c5e954b378396e8.jpg";